import script from "./AdminProductionMap.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductionMap.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductionMap.vue?vue&type=style&index=0&id=6f67c1f2&scoped=true&lang=css"
script.__scopeId = "data-v-6f67c1f2"

export default script